import OfferResultDialog from "./OfferResultDialog";

export default OfferResultDialog;
